import { render, staticRenderFns } from "./UiTextField.vue?vue&type=template&id=0863be93&"
import script from "./UiTextField.vue?vue&type=script&lang=js&"
export * from "./UiTextField.vue?vue&type=script&lang=js&"
import style0 from "./UiTextField.vue?vue&type=style&index=0&id=0863be93&prod&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports